if (!customElements.get('fgo-related-products')) {
  customElements.define('fgo-related-products', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';
      fetch(this.dataset.url)
        .then(response => {
          if (!response.ok) throw new Error('Recommendations unavailable');
          return response.text();
        })
        .then(html => {
          if (!this.isConnected) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const result = Array.from(doc.querySelectorAll('fgo-related-products'))
            .find(node => node.dataset.sectionId === this.dataset.sectionId);
          if (result && result.querySelector('.product-card')) this.innerHTML = result.innerHTML;
        })
        .catch(() => { /* Keep the server-rendered fallback products. */ });
    }
  });
}
